import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "../ui";
import { NAV } from "./Sidebar";
import BrandSwitcher from "./BrandSwitcher";

type TopbarProps = {
  onMenuClick?: () => void;
};

const Topbar: React.FC<TopbarProps> = ({ onMenuClick }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = NAV.find((n) => pathname.startsWith(n.path));
  const [query, setQuery] = useState("");

  const handleRefresh = () => {
    window.dispatchEvent(new CustomEvent("admin:refresh"));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = query.trim();
    if (!q) return;
    // `search` is the filter the users list actually reads, and it covers id,
    // email, name and billing id. This used to send `user_id`, which nothing
    // read, so the box navigated to an unfiltered list.
    navigate(`/users?search=${encodeURIComponent(q)}`);
    setQuery("");
  };

  return (
    <header className="topbar">
      <button className="menu-btn" onClick={onMenuClick} aria-label="Open menu">
        <Icon name="menu" size={20} />
      </button>
      <div className="crumb">
        <span>Admin</span>
        <Icon name="chevRight" size={12} />
        <span className="here">{current ? current.label : ""}</span>
      </div>
      <form className="topbar-search" onSubmit={handleSubmit}>
        <Icon name="search" />
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search users by id, email or name…"
        />
        <span className="kbd">⌘K</span>
      </form>
      <div className="topbar-right">
        <BrandSwitcher />
        <button
          className="btn subtle"
          style={{ position: "relative", padding: 7 }}
          aria-label="Notifications"
        >
          <Icon name="bell" />
          <span
            style={{
              position: "absolute",
              top: 4,
              right: 5,
              width: 6,
              height: 6,
              borderRadius: 999,
              background: "var(--danger)",
            }}
          />
        </button>
        <button className="btn ghost" onClick={handleRefresh}>
          <Icon name="refresh" /> <span className="topbar-refresh-label">Refresh</span>
        </button>
      </div>
    </header>
  );
};

export default Topbar;
